/**************************************************
 * Nombre:       Tarjeta_Alerta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import TituloTexto from "./Componentes/TituloTexto";
import {Backup, KeyboardDoubleArrowDown, KeyboardDoubleArrowUp, ReceiptLong} from '@mui/icons-material'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import {PDFDownloadLink} from "@react-pdf/renderer";
import Pdf_Recibo from "../../CodNegocio/Pdfs/Pdf_Recibo";
import Dialogo_Subir_Foto from "../Dialogos/Dialogo_Subir_Foto";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";


const Tarjeta_Alerta = ({alto = 212, item, recargar, antesDe, openAlerta, setOpenAlerta}) => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir, cerrar} = useDialogo({
        Componente: Dialogo_Subir_Foto,
        titulo: 'Foto o Captura de Pantalla',
        realizado: recargar
    })
    dayjs.locale('es');

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#ff8a8a',
                p: 2,
                borderRadius: 4,
                color: '#000',
                minHeight: alto,
            }}
        >

            <Dialogo/>

            <Grid container size={11} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 600}}>Accion Necesaria</Typography>
            </Grid>

            <Grid container size={12} sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 3}}>
                <TituloTexto titulo={'Accion a Realizar'} texto={'Consingnar y subir pantallazo o foto de consignacion'}
                             textoS={18}
                             colorT={'#000000'}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 2}}>
                <PDFDownloadLink
                    document={<Pdf_Recibo item={item} antesDe={antesDe}/>}
                    fileName={"Recibo #" + item.consecutivo}
                    style={{textDecoration: "none"}}>
                    <Button
                        color={'info'} startIcon={<ReceiptLong/>}>Descargar</Button>
                </PDFDownloadLink>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-end', mt: 2}}>
                <Button
                    onClick={() => abrir(item)}
                    color={'action'} startIcon={<Backup/>}>Subir Foto</Button>
            </Grid>

            {sCell && <>

                <Grid container size={2} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <IconButton
                        onClick={() => setOpenAlerta(!openAlerta)}
                        sx={{backgroundColor: '#fff'}}>
                        {openAlerta ?
                            <KeyboardDoubleArrowUp sx={{mb: -0.2,}}/>
                            :
                            <KeyboardDoubleArrowDown sx={{mb: -0.2,}}/>
                        }
                    </IconButton>
                </Grid>

                {!openAlerta &&
                    <Grid container size={10} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <TituloTexto titulo={'Accion'} texto={'Subir recibo pantallazo o foto'}
                                     textoS={18}
                                     colorT={'#000000'}/>
                    </Grid>
                }

            </>
            }

        </Grid>
    )

}
export default Tarjeta_Alerta